import { getLanguage } from '@/utils/utils'

// 角色列表
export const roleList = [
    { value: 100, label: getLanguage('owner') },
    { value: 10, label: getLanguage('admin') },
    { value: 9, label: getLanguage('superProxy') },
    { value: 8, label: getLanguage('oneProxy') },
    { value: 7, label: getLanguage('twoProxy') },
    { value: 6, label: getLanguage('threeProxy') },
    { value: 5, label: getLanguage('fourProxy') },
    { value: 1, label: getLanguage('member') },
]

// 游戏类型列表
export const kindList = [
    { value: 1, label: getLanguage('nlh') },
    { value: 2, label: getLanguage('six') },
    { value: 3, label: getLanguage('cowboy') },
    { value: 4, label: getLanguage('plo') },
    { value: 5, label: getLanguage('mtt') },
    { value: 6, label: getLanguage('ofc') },
    { value: 8, label: getLanguage('aof') },
]

// 奖池分配类型列表
export const bonusTypesList = [
    { value: 1, label: getLanguage('tenPercent') },
    { value: 2, label: getLanguage('fifteenPercent') },
    { value: 3, label: getLanguage('twentyPercent') },
    { value: 4, label: getLanguage('thirtyPercent') },
    { value: 10, label: getLanguage('fixedBonus') },
]

// 状态列表
export const statusList = [
    { value: 0, label: getLanguage('notPublish') },
    { value: 1, label: getLanguage('notStart') },
    { value: 2, label: getLanguage('process') },
    { value: 3, label: getLanguage('finished') },
    { value: 4, label: getLanguage('dissolved') },
]

// 状态列表1
export const statusList1 = [
    { value: 0, label: getLanguage('notPublish') },
    { value: 1, label: getLanguage('published') },
    { value: 2, label: getLanguage('notStart') },
    { value: 3, label: getLanguage('process') },
    { value: 4, label: getLanguage('finished') },
]

// 状态列表2
export const statusList2 = [
    { value: 0, label: getLanguage('notStart') },
    { value: 1, label: getLanguage('process') },
    { value: 2, label: getLanguage('finished') },
    { value: 3, label: getLanguage('deleted') },
]

// 状态列表3
export const statusList3 = [
    { value: 1, label: getLanguage('notStart') },
    { value: 2, label: getLanguage('process') },
    { value: 3, label: getLanguage('finished') },
]

// 状态列表4
export const statusList4 = [
    { value: 1, label: getLanguage('notPublish') },
    { value: 2, label: getLanguage('published') },
    { value: 3, label: getLanguage('process') },
    { value: 4, label: getLanguage('finished') },
    { value: 5, label: getLanguage('offline') },
]

// 状态列表5
export const statusList5 = [
    { value: 2, label: getLanguage('pendingReview') },
    { value: 3, label: getLanguage('reviewedAndReissued') },
    { value: 4, label: getLanguage('reviewedAndNotReissued') },
    { value: 5, label: getLanguage('systemReissue') },
    { value: 6, label: getLanguage('systemNotReissue') },
]

// 盲注结构
export const blindTypesList = [
    { value: 1, label: getLanguage('standard') },
    { value: 2, label: getLanguage('speediness') },
    { value: 3, label: getLanguage('deepChip') },
]

// 发布类型
export const publishTypeList = [
    { value: -1, label: getLanguage('manualPublish') },
    { value: 0, label: getLanguage('autoPublish') },
    { value: 1, label: getLanguage('everyDayPublish') },
    { value: 2, label: getLanguage('everyWeekPublish') },
]

// 星期列表
export const weekList = [
    { value: 1, label: getLanguage('monday') },
    { value: 2, label: getLanguage('tuesday') },
    { value: 3, label: getLanguage('wednesday') },
    { value: 4, label: getLanguage('thursday') },
    { value: 5, label: getLanguage('friday') },
    { value: 6, label: getLanguage('saturday') },
    { value: 7, label: getLanguage('sunday') },
]

// 即时战绩
export const profitTypeList = [
    { value: 0, label: getLanguage('all') },
    { value: 1, label: getLanguage('tablePlayers') },
    { value: 2, label: getLanguage('oneself') },
]

// 鱿鱼模式
export const squidTypeList = [
    { value: 1, label: getLanguage('singleMode') },
    { value: 2, label: getLanguage('normalMode') },
    { value: 3, label: getLanguage('crazyModel') },
]

// 游戏模式
export const gameTypeList = [
    { value: 1, label: getLanguage('normalMode') },
    { value: 2, label: getLanguage('bloodBattleMode') },
    { value: 3, label: getLanguage('bloodFlowsInOut') },
]

// 操作顺序
export const operModList = [
    { value: 1, label: getLanguage('meantime') },
    { value: 2, label: getLanguage('inOrder') },
]

// 类型
export const typeList = [
    { value: 1, label: getLanguage('hand') },
    { value: 2, label: getLanguage('minute') },
]

// 排序列表
export const sortList = [
    { value: 1, label: getLanguage('level') },
    { value: 2, label: getLanguage('playPeople') },
    { value: 3, label: getLanguage('gambleOpenTime') },
]

// 分页天数列表
export const pageSizeList = [
    { value: 7, label: `7 ${getLanguage('day')}/${getLanguage('page')}` },
    { value: 30, label: `30 ${getLanguage('day')}/${getLanguage('page')}` },
    { value: 31, label: `31 ${getLanguage('day')}/${getLanguage('page')}` },
]

// 语言类型列表
export const languageTypeList = [
    { value: 'zh', label: getLanguage('zh') }, // 中文繁体
    { value: 'en', label: getLanguage('en') }, // 中文繁体
    { value: 'th', label: getLanguage('th') }, // 泰文
    { value: 'vn', label: getLanguage('vn') }, // 越南文
    { value: 'id', label: getLanguage('id') }, // 印尼文
    { value: 'pt', label: getLanguage('pt') }, // 葡萄牙文
    { value: 'ko', label: getLanguage('ko') }, // 韩文
    { value: 'spa', label: getLanguage('spa') }, // 西班牙文
    { value: 'lao', label: getLanguage('lao') }, // 老挝语
    { value: 'my', label: getLanguage('my') }, // 缅甸语
    { value: 'jp', label: getLanguage('jp') }, // 日文
    { value: 'bn', label: getLanguage('bn') }, // 孟加拉语
    { value: 'rs', label: getLanguage('rs') }, // 俄罗斯语
    { value: 'tr', label: getLanguage('tr') }, // 土耳其语
]

